import authAxios from "../authAxios";

// A trip leader's /duck-fam-discount link. Its code used to live only in the
// opening tab's sessionStorage, so a guest who then booked in the app (whose
// checkout runs in a fresh WebView) or in another tab lost the 5% and the
// leader lost the duck-fam credit. Now:
//   - signed in: the invite is saved on the server (POST /v1/trip/duck-invite);
//     the promotions lookup and the charge apply it on any device;
//   - signed out: it waits in localStorage and is saved on the next sign-in.
const PENDING_KEY = "pending_duck_invite";
const PENDING_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export const isSignedIn = () =>
  Boolean(localStorage.getItem("JWT_TOKEN") && localStorage.getItem("USER_ID"));

// Resolves to { recorded, reason?, leader_first_name? }.
export const saveDuckInvite = (duckCode, tripId, source) =>
  authAxios
    .post(
      "/v1/trip/duck-invite",
      { duck_code: duckCode, trip_id: Number(tripId), source },
      // Background call: a 401 here must never sign the guest out.
      { skipAuthRedirect: true }
    )
    .then((res) => res.data?.data);

export const rememberPendingDuckInvite = (duckCode, tripId) => {
  try {
    localStorage.setItem(
      PENDING_KEY,
      JSON.stringify({ duck: duckCode, trip: String(tripId), at: Date.now() })
    );
  } catch (_) {
    // storage full / blocked — the same-tab sessionStorage path still works
  }
};

// Called once the user is known (App.js). Keeps the pending invite on network
// errors and 5xx so the next load retries; drops it once the server has given
// a real answer (saved, or a 4xx other than 401 — a link that can't apply).
export const flushPendingDuckInvite = async () => {
  if (!isSignedIn()) return;
  let pending = null;
  try {
    pending = JSON.parse(localStorage.getItem(PENDING_KEY) || "null");
  } catch (_) {
    pending = null;
  }
  if (!pending?.duck || !pending?.trip) return;
  if (Date.now() - (pending.at || 0) > PENDING_TTL_MS) {
    localStorage.removeItem(PENDING_KEY);
    return;
  }
  try {
    await saveDuckInvite(pending.duck, pending.trip, "login_flush");
    localStorage.removeItem(PENDING_KEY);
  } catch (err) {
    const status = err?.response?.status;
    // 401 = session expired: keep it for the next sign-in.
    if (status && status < 500 && status !== 401) localStorage.removeItem(PENDING_KEY);
  }
};
